import React, { useEffect, useState } from "react";
import "./index.css";
import setaBaixo from "../../assets/images/pngs/setaBaixo.png";
import resgatados from "../../assets/images/pngs/resgatados.png";

export default function ItensQueridos({ lista }) {
  return (
    <div className="py-5">
      {lista?.map((item, index) => (
        <div
          key={index}
          className="d-flex flex-column flex-md-row justify-content-center align-items-center"
        >
          <div className="circuloAmarelo">
            <div className="circuloPosicao">{index + 1}°</div>
            <img className="imagemPosicao" src={item.urlImagem} />
          </div>
          <div>
            <div className="texto-posicao">{item.nomeProduto}</div>
            <hr className=""></hr>
          </div>
        </div>
      ))}
    </div>
  );
}
